module.exports = __webpack_public_path__ + "img/MediumMove-80.9973dc39.gif";